import paths from '@/router/paths';
export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: '#276a8a',
        text: 'Đăng nhập thành công'
      };
      this.$router.replace({ path: '/tai-khoan' });
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: '#276a8a',
        text: 'Đăng xuất thành công'
      };
      localStorage.clear();
      this.$router.replace('/dang-nhap');
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      localStorage.clear();
      this.$router.push('/dang-nhap');
      // this.$message.error('Token has expired');
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      // this.$message.error(msg);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      // this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      // this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: '#276a8a',
        text: msg
      };
    }
  },
  {
    name: 'APP_RESOURCE_FAILED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'error',
        text: msg
      };
    },
  },
  {
    name: 'APP_NOTIFY',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        timeout: 6000,
        color: '#276a8a',
        text: msg
      };
    }
  },
  {
    name: 'APP_NAVIGATE',
    callback: function (viewName) {
      const item = _.find(paths, {name: viewName})
      if(item) {
        this.$router.replace({ path: item.path });
      }
    }
  },
  {
    name: 'PRE_SAVE_DATA',
    callback: function () {
      if(this.$refs.form.validate()) {
        this.$root.$emit('REQUEST_SAVE_DATA');
      }
    }
  },
  {
    name: 'REQUEST_REFRESH_DATA',
    callback: function () {
      this.$root.$emit('REQUEST_REFRESH_DATA');
    }
  },
  {
    name: 'REQUEST_DELETE_DATA',
    callback: function (id, message = '') {
      this.delDialog = true;
      this.delId = id;
      this.delMessage = message;
    }
  },
];
